import { serviceModel } from "../../../../models";
import { InlineStartBillingMenuItem } from "./InlineStartBillingControl";
export function clearPreviousSelection(serviceId, previousItem, handlers) {
  var _handlers$onPausedCha, _handlers$onBillOnAcc, _handlers$onStartBill;
  switch (previousItem) {
    case InlineStartBillingMenuItem.ManualInitiation:
      (_handlers$onPausedCha = handlers.onPausedChange) === null || _handlers$onPausedCha === void 0 || _handlers$onPausedCha.call(handlers, serviceId, false);
      break;
    case InlineStartBillingMenuItem.AcceptanceDate:
    case InlineStartBillingMenuItem.Today:
      (_handlers$onBillOnAcc = handlers.onBillOnAcceptanceChange) === null || _handlers$onBillOnAcc === void 0 || _handlers$onBillOnAcc.call(handlers, serviceId, false);
      break;
    case InlineStartBillingMenuItem.SpecificDate:
      (_handlers$onStartBill = handlers.onStartBillingAtChange) === null || _handlers$onStartBill === void 0 || _handlers$onStartBill.call(handlers, serviceId, null);
      break;
  }
}
export function applyNewSelection(serviceId, newItem, handlers, getInitialEffectiveDate) {
  var _handlers$onStartBill2, _handlers$onBillOnAcc2, _handlers$onPausedCha2;
  switch (newItem) {
    case InlineStartBillingMenuItem.NextBillingDay:
      break;
    case InlineStartBillingMenuItem.SpecificDate:
      (_handlers$onStartBill2 = handlers.onStartBillingAtChange) === null || _handlers$onStartBill2 === void 0 || _handlers$onStartBill2.call(handlers, serviceId, getInitialEffectiveDate());
      break;
    case InlineStartBillingMenuItem.AcceptanceDate:
    case InlineStartBillingMenuItem.Today:
      (_handlers$onBillOnAcc2 = handlers.onBillOnAcceptanceChange) === null || _handlers$onBillOnAcc2 === void 0 || _handlers$onBillOnAcc2.call(handlers, serviceId, true);
      break;
    case InlineStartBillingMenuItem.ManualInitiation:
      (_handlers$onPausedCha2 = handlers.onPausedChange) === null || _handlers$onPausedCha2 === void 0 || _handlers$onPausedCha2.call(handlers, serviceId, true);
      break;
  }
}
export function getStartBillingSelection(service) {
  if (serviceModel.isPaused(service)) {
    return InlineStartBillingMenuItem.ManualInitiation;
  }
  if (serviceModel.startBillingAt(service)) {
    return InlineStartBillingMenuItem.SpecificDate;
  }
  if (serviceModel.isBillOnPeriodBeforeNextBilling(service)) {
    if (serviceModel.isFromAmendment(service)) {
      return InlineStartBillingMenuItem.Today;
    }
    return InlineStartBillingMenuItem.AcceptanceDate;
  }
  return InlineStartBillingMenuItem.NextBillingDay;
}